"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.zoomPoint = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _mapActions = require("../actions/mapActions");

var _LegendItems = require("./LegendItems");

var _clusterTf = _interopRequireDefault(require("../assets/cluster-tf.svg"));

var _managedTf = _interopRequireDefault(require("../assets/managed-tf.svg"));

var _bothTf = _interopRequireDefault(require("../assets/both-tf.svg"));

var _criticalTf = _interopRequireDefault(require("../assets/critical-tf.svg"));

var _permissions = _interopRequireDefault(require("../config/permissions"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var zoomPoint = 14;
exports.zoomPoint = zoomPoint;

var Legend = function Legend(_ref) {
  var userType = _ref.userType;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedLayers = _useState2[0],
      setSelectedLayers = _useState2[1];

  var mapView = (0, _reactRedux.useSelector)(function (state) {
    return state.mapViewReducer.mapView;
  });
  var loadShedLayers = (0, _reactRedux.useSelector)(function (state) {
    return state.allowedLayerReducer.loadshedLayers;
  });
  (0, _react.useEffect)(function () {
    var nextLayers = mapView.zoom <= zoomPoint ? Object.keys(selectedLayers).filter(function (layerName) {
      return selectedLayers[layerName];
    }) : ['transformers'];
    dispatch((0, _mapActions.setActiveLayer)(nextLayers));
  }, [dispatch, selectedLayers, mapView]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    id: 'legend-label'
  }, mapView.zoom <= zoomPoint ? 'OPERATION SELECTION' : 'TRANSFORMERS'), /*#__PURE__*/_react.default.createElement("div", {
    className: 'legend-body'
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-legend'
  }, mapView.zoom <= zoomPoint ? loadShedLayers === null || loadShedLayers === void 0 ? void 0 : loadShedLayers.filter(function (layer) {
    return layer.name !== 'transformers';
  }).map(function (layer) {
    return /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
      key: layer.name,
      name: layer.displayName,
      id: layer.name,
      toggleable: true,
      value: selectedLayers[layer.name],
      onToggle: function onToggle() {
        var nextLayers = Object.assign({}, _objectSpread(_objectSpread({}, selectedLayers), {}, _defineProperty({}, layer.name, !selectedLayers[layer.name])));
        setSelectedLayers(nextLayers);
      },
      icon: /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '16px',
          height: '16px',
          backgroundColor: layer.color
        }
      }, "\xA0")
    });
  }) : /*#__PURE__*/_react.default.createElement("div", {
    id: 'map-legend'
  }, /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
    id: 'critical-legend-item',
    name: 'Critical Transformers',
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _criticalTf.default,
      alt: 'Critical TF icon'
    })
  }), _permissions.default[userType].allowAllTransformers && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
    id: 'managed-legend-item',
    name: 'Managed Transformers',
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _managedTf.default,
      alt: 'Managed TF icon'
    })
  }), /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
    id: 'both-legend-item',
    name: 'Critical and Managed Transformers',
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _bothTf.default,
      alt: 'Both TF icon'
    })
  })), /*#__PURE__*/_react.default.createElement(_LegendItems.LegendItem, {
    id: 'cluster-legend-item',
    name: 'Mulitple Transformers',
    icon: /*#__PURE__*/_react.default.createElement("img", {
      src: _clusterTf.default,
      alt: 'Both TF icon'
    })
  })))));
};

Legend.propTypes = {
  userType: _propTypes.default.any.isRequired
};
var _default = Legend;
exports.default = _default;